export default __webpack_public_path__ + "static/media/line-edit-v2.c700832e.svg";